// Coordonnées et liens externes de la garderie.
// Centralisés ici : ils apparaissent dans le footer, la page Contact et
// les données structurées de public/index.html (à mettre à jour en parallèle).

export const PHONE_DISPLAY = '07 56 80 41 59';
export const PHONE_HREF = 'tel:0756804159';

export const EMAIL = 'contact@lemondedeschiensetdesnacs.com';

export const SOCIAL = {
  instagram: 'https://www.instagram.com/lemondedeschiensetdesnac/',
  facebook: 'https://www.facebook.com/p/Emilie-Pet-Sitting-61583428500404/',
};
